import ConfigurationDisclosureComponent from "@/app/components/routes/auth_routes/Configuration/DisclosureConfiguration";

const ConfigurationIndexPage = () => {
  return <ConfigurationDisclosureComponent />;
};

export default ConfigurationIndexPage;
